import type { CompanyRow } from "@/pages/company-list/model";
import { BaseTable } from "@/shared/ui/base-table";
import type { Column } from "@/shared/ui/base-table/types";
import { Typography } from "@mui/material";
import type { TrackManager } from "@x-mile/api-contract";

export type CompanyTableProps = {
  companies: CompanyRow[];
};

const columns: Column<TrackManager.schemas.CollectionCompany>[] = [
  {
    key: "name",
    label: "会社名",
    cell: (row) => {
      return <Typography>{row.name}</Typography>;
    },
  },
  {
    key: "zipCode",
    label: "郵便番号",
    cell: (row) => {
      return <Typography>{row.zipCode}</Typography>;
    },
  },
  {
    key: "address",
    label: "住所",
    cell: (row) => {
      return <Typography>{row.address}</Typography>;
    },
  },
  {
    key: "phoneNumber",
    label: "電話番号",
    cell: (row) => {
      return <Typography>{row.phoneNumber}</Typography>;
    },
  },
  {
    key: "faxNumber",
    label: "FAX番号",
    cell: (row) => {
      return <Typography>{row.faxNumber}</Typography>;
    },
  },
  {
    key: "email",
    label: "メールアドレス",
    cell: (row) => {
      return <Typography>{row.email}</Typography>;
    },
  },
];

export const CompanyTable = ({ companies }: CompanyTableProps) => {
  return (
    <BaseTable
      rows={companies}
      columns={columns}
      to="/admin/companies/$id"
      params={(val) => ({ id: val.id })}
      noDataMessage="企業情報がありません。"
    />
  );
};
